<template>
  <div class="code">
    <div class="code-game">
      <MenuGames
        :items="phrases"
        :current="currentPhrase.name.toLowerCase().replace(/ /g, '')"
        @init="init"
      />
      <Phrase :currentPhrase="currentPhrase" :gameName="gameName" />
    </div>
    <div class="code-game-information">
      <div>
        <h3 v-if="game == 'chappe'">
          ÉTAPE 1 : dans le tableau de correspondance ci-dessous, retrouvez le
          nombre correspondant à chacune des positions successives des bras
          articulés :
        </h3>
        <h3 v-else-if="game == 'baudot'">
          À l’aide du tableau de déchiffrage ci-dessous, retrouvez à quelle lettre (ou quel chiffre ou signe) correspond chaque combinaison de cinq 0 et 1 successifs :
        </h3>
        <h3 v-else>
          À l’aide du tableau de déchiffrage ci-dessous, retrouvez à quelle lettre (ou quel chiffre) correspond chaque combinaison de signaux :
        </h3>
        <img
          :src="require('@/assets/' + gameName + '/dechiffrage' + extension)"
          alt=""
          style="width:100%"
        />
        <div class="code-game-information-step2" v-if="gameName == 'chappe'">
          <h3>
            ÉTAPE 2 : deux positions des bras articulés = 1 mot ! Grâce au livre
            de déchiffrage, retrouvez les mots codés :
          </h3>
          <a href="chappe-livre.jpg" target="_blank" style="align-self: flex-start">
            <img
                :src="require('@/assets/chappe/livre-dechiffrage.png')"
                alt=""
                width="150"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuGames from "../layout/MenuGames.vue";
import Phrase from "../layout/Phrase.vue";
import phrases from "./config/phrases.json";

export default {
  name: "MorseGames",
  components: {
    MenuGames,
    Phrase,
  },
  props: {
    gameName: String,
  },
  data: () => ({
    currentPhrase: {},
    phrases: {},
    extension: "",
  }),
  watch: {
    gameName: function () {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init(event = 0) {
      if (event.param) {
        this.currentPhrase = phrases.phrases[this.gameName][event.param];
      } else {
        this.currentPhrase = phrases.phrases[this.gameName]["phrase1"];
      }
      this.phrases = phrases.phrases[this.gameName];
      this.extension = this.gameName == "chappe" ? ".jpg" : ".png";
    },
  },
};
</script>

<style lang="scss">
.code {
  display: flex;
  &-game {
    margin: 0 auto;
    padding-right: 40px;
    width: 60%;

    &-information {
      width: 40%;
      margin: 4rem auto;
      h3 {
        text-align: left;
        font-size: 0.9rem;
      }
      &-step2 {
        display: flex;
        flex-direction: column;
      }
    }
  }

  @media (max-width: 800px) {
    flex-direction: column;

    &-game, &-game-information {
      width: 100%;
    }
    &-game {
      padding-bottom: 60px;
    }
    &-game-information {
      order: -1;
    }
  }
}
</style>